import React from 'react';

import type { BaseLineIconProps } from '../../utils';
import { assetTypeToBackgroundColor } from '../../utils';
import { Icon } from '../BaseIcon/Icon';

type AccountTypeIconProps = BaseLineIconProps & {
  /**
   * Whether or not the Ledger Account is linked.
   * Currently DOES NOT visually differentiate the icons.
   */
  linked?: boolean;
};

export const AccountTypeIcon = ({
  type,
  size = 'sm',
  disabled = false,
  // eslint-disable-next-line unused-imports/no-unused-vars -- we might wanna do something with this in the future, so keeping this prop for now but not passing it thru
  linked = false,
}: AccountTypeIconProps): JSX.Element => (
  <Icon
    data-testid={`account-type-icon-${type}`}
    type={type}
    size={size}
    backgroundColor={disabled ? 'gray' : assetTypeToBackgroundColor[type]}
  />
);
